import moment from "moment";

class TimeUtil {
  static getTimeRange(label) {
    let startTime, endTime;
    switch (label) {
      case "今天":
        startTime = moment().format("YYYY-MM-DD 00:00:00");
        endTime = moment().format("YYYY-MM-DD 23:59:59");
        break;
      case "昨天":
        startTime = moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00");
        endTime = moment().subtract(1, "days").format("YYYY-MM-DD 23:59:59");
        break;
      case "本周":
        startTime = moment().day("Monday").format("YYYY-MM-DD 00:00:00");
        endTime = moment().day("Monday").day(+7).format("YYYY-MM-DD 23:59:59");
        break;
      case "近7天":
        startTime = moment().subtract(6, "days").format("YYYY-MM-DD 00:00:00");
        endTime = moment().format("YYYY-MM-DD 23:59:59");
        break;
      case "近30天":
        startTime = moment().subtract(29, "days").format("YYYY-MM-DD 00:00:00");
        endTime = moment().format("YYYY-MM-DD 23:59:59");
        break;
      case "本月":
        startTime = moment().format("YYYY-MM");
        endTime = moment().format("YYYY-MM-DD 23:59:59");
        break;
      case "本年":
        startTime = moment().format("YYYY");
        endTime = moment().format("YYYY-MM-DD 23:59:59");
        break;
    }

    // console.log(startTime, endTime);
    return [startTime, endTime];
  }
}

export default TimeUtil;


//  //本季度
//  start_time =moment().format("YYYY-")+(moment().quarter()*3-3+1+"-1 00:00:00");
//  end_time = moment(moment().format("YYYY-")+(moment().quarter()*3+"-1 00:00:00")).endOf("month").format("YYYY-MM-DD 23:59:59");

//  //本年度
//  start_time = moment().format("YYYY-")+"1-1 00:00:00";
//  end_time = moment().format("YYYY-")+"12-31 23:59:59";
